import React, { Component } from 'react';
import { string, func } from 'prop-types';
import { translate } from 'react-i18next';

import { LockIcon } from '@snapask/common-components';

import * as loadingStates from '@dragonfruit/constants/loadingState';
import AnimatedCard from '@dragonfruit/components/authCard/AnimatedCard';

import styles from './BraintreeLoader.scss';

const TIME_EACH_SLIDE = 2000;
const MINIMUM_SLIDES = 2;
const MINIMUM_TIME = TIME_EACH_SLIDE * MINIMUM_SLIDES;

class BraintreeLoader extends Component {
  static propTypes = {
    loadingStatus: string.isRequired,
    t: func.isRequired,
    onError: func.isRequired,
    onSuccess: func.isRequired,
  };

  state = {
    stringIndex: 0,
    startTime: new Date(),
    stringsLength: this.props.t('purchase.braintree.loading.subTitles', {
      returnObjects: true,
      defaultValue: [],
    }).length,
  };

  componentDidMount() {
    setTimeout(() => {
      this.setIndex(this.state.stringIndex);
    }, TIME_EACH_SLIDE);

    // Preventing body scroll when mounted
    document.body.style.overflow = 'hidden';
  }

  componentWillReceiveProps(nextProps) {
    const { loadingStatus } = nextProps;

    if (loadingStatus === this.props.loadingStatus) {
      return;
    }

    const { startTime } = this.state;
    const endTime = new Date();

    const difference = endTime - startTime;

    if (difference >= MINIMUM_TIME) {
      this.checkSuccess(loadingStatus);
    } else {
      setTimeout(() => {
        this.checkSuccess(this.props.loadingStatus);
      }, MINIMUM_TIME - difference);
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  setIndex = index => {
    const stringIndex = index + 1;
    // Prevent setting state on unmounted
    // component.
    if (stringIndex === this.state.stringsLength) {
      return;
    }

    this.setState(
      {
        stringIndex,
      },
      () =>
        setTimeout(() => {
          this.setIndex(stringIndex);
        }, TIME_EACH_SLIDE)
    );
  };

  checkSuccess = status => {
    const { onSuccess, onError } = this.props;

    switch (status) {
      case loadingStates.READY: {
        onSuccess();
        break;
      }
      case loadingStates.ERROR: {
        onError();
        break;
      }
      default:
        break;
    }
  };

  render() {
    const { t } = this.props;
    const { stringIndex } = this.state;

    const strings = t('purchase.braintree.loading.subTitles', {
      returnObjects: true,
      defaultValue: [],
    });

    return (
      <div className={styles.root}>
        <div className={styles.text}>
          <div className={styles.icon}>
            <LockIcon width={48} height={48} />
          </div>

          <h4>{t('purchase.braintree.loading.title')}</h4>
          <AnimatedCard activeCard={stringIndex.toString()} toRight animate>
            {strings.map((string, index) => (
              <p key={index}>{string}</p>
            ))}
          </AnimatedCard>
        </div>
      </div>
    );
  }
}

export default translate('purchase')(BraintreeLoader);



// WEBPACK FOOTER //
// ./app/components/PaymentHandler/BraintreeCheckout/components/BraintreeLoader/BraintreeLoader.jsx